import React, { useEffect, useState } from 'react';
import { motion, AnimatePresence } from 'framer-motion';
import { Link } from "react-router-dom";

import heroImg1  from './asset/image/hero1.jpg';
import heroImg2  from './asset/image/hero2.jpg';
import heroImg3  from './asset/image/hero3.jpg';
import event1    from './asset/image/orientation01.jpg';
import event2    from './asset/image/img06.jpg';
import event3    from './asset/image/img08.jpg';
import event4    from './asset/image/event4.jpg';
import event5    from './asset/image/event5.jpg';
import event6    from './asset/image/event6.jpg';
import ceoImg       from "./asset/image/ceo.jpg";
import ceoImg1      from "./asset/image/ceoimg.jpg";
import directorImg  from "./asset/image/director.jpg";
import profAqeel    from "./asset/image/profAqeel.jpg";
import founderImg   from "./asset/image/hero1.jpg";
import mamFaiza     from "./asset/image/mamFaiza.jpg";
import sirDaniyal   from "./asset/image/sirDaniyal.jpg";
import sirSikander  from "./asset/image/sirSikander.jpg";
import mamHafsa     from "./asset/image/mamHafsa.jpg";
import mamBatool    from "./asset/image/mam Batool.jpg";
import sirAmjad     from "./asset/image/sirAmjad.jpg";
import sirRafay     from "./asset/image/sir rafay.jpg";
import mamShireen   from "./asset/image/mamShireen.jpg";
import mamAnum      from "./asset/image/mamAnum.jpg";
import sirRashid    from "./asset/image/sirRashid.jpg";
import mamShehrBano from "./asset/image/mamShehrBano.jpg";
import sirNadeem    from "./asset/image/SirNadeem.jpg";
import sirBasit    from "./asset/image/SirBasit.jpg";
import msTaskeen    from "./asset/image/MsTaskeen.jpg";
import mamRamsha    from "./asset/image/MamRamsha.jpg";
import mamSadia    from "./asset/image/MamSadia.jpg";
import sirAhsan    from "./asset/image/SirAhsan.jpg";
import sirArbab    from "./asset/image/SirArbab.jpg";
import sirArslan    from "./asset/image/SirArslan.jpg";
import sirGhazanfar    from "./asset/image/sirGhazanfar.jpg";


/* ─── CSS ─── */
const css = `
@import url('https://fonts.googleapis.com/css2?family=Playfair+Display:ital,wght@0,400;0,600;0,700;0,900;1,400&family=DM+Sans:ital,opsz,wght@0,9..40,300;0,9..40,400;0,9..40,500;0,9..40,600;1,9..40,400&display=swap');

:root {
  --navy:#0A1931; --blue:#1A3A6E; --gold:#C9A84C; --gold-lt:#E8C97A;
  --light:#F7F9FC; --white:#FFFFFF; --gray:#6B7A99; --gray-lt:#EEF2F8;
}

.hm *, .hm *::before, .hm *::after { box-sizing:border-box; margin:0; padding:0; }
.hm { font-family:'DM Sans',sans-serif; color:var(--navy); background:#fff; }

/* NAV */
.hm-nav { position:sticky; top:0; z-index:200; background:rgba(10,25,49,.97); backdrop-filter:blur(14px); border-bottom:1px solid rgba(201,168,76,.18); }
.hm-nav-inner { max-width:1280px; margin:0 auto; padding:0 40px; height:72px; display:flex; align-items:center; justify-content:space-between; gap:12px; }
.hm-nav-links { display:flex; gap:32px; list-style:none; }
.hm-nav-links a { color:rgba(255,255,255,.72); text-decoration:none; font-size:14px; font-weight:500; letter-spacing:.4px; transition:color .2s; position:relative; }
.hm-nav-links a::after { content:''; position:absolute; bottom:-4px; left:0; right:0; height:2px; background:var(--gold); transform:scaleX(0); transform-origin:left; transition:transform .25s; }
.hm-nav-links a:hover { color:var(--gold-lt); }
.hm-nav-links a:hover::after { transform:scaleX(1); }
.hm-nav-cta { background:var(--gold); color:var(--navy); font-weight:700; font-size:13px; padding:10px 24px; border-radius:100px; text-decoration:none; transition:background .2s,transform .2s; white-space:nowrap; }
.hm-nav-cta:hover { background:var(--gold-lt); transform:translateY(-1px); }
.hm-burger { display:none; flex-direction:column; justify-content:center; align-items:center; gap:5px; width:44px; height:44px; background:rgba(255,255,255,.07); border:1px solid rgba(201,168,76,.3); border-radius:10px; cursor:pointer; flex-shrink:0; }
.hm-burger span { display:block; width:22px; height:2px; background:var(--gold); border-radius:2px; transition:transform .3s,opacity .3s; }
.hm-burger.open span:nth-child(1) { transform:translateY(7px) rotate(45deg); }
.hm-burger.open span:nth-child(2) { opacity:0; }
.hm-burger.open span:nth-child(3) { transform:translateY(-7px) rotate(-45deg); }
.hm-drawer { position:fixed; top:72px; left:0; right:0; z-index:199; background:rgba(8,18,38,.98); backdrop-filter:blur(20px); border-bottom:1px solid rgba(201,168,76,.2); padding:16px 20px 24px; display:none; flex-direction:column; gap:2px; pointer-events:none; opacity:0; transform:translateY(-8px); transition:opacity .3s,transform .3s; }
.hm-drawer.visible { display:flex; }
.hm-drawer.open { pointer-events:all; opacity:1; transform:translateY(0); }
.hm-drawer a { display:block; padding:13px 16px; color:rgba(255,255,255,.78); text-decoration:none; font-size:15px; font-weight:500; border-radius:10px; border-bottom:1px solid rgba(255,255,255,.06); transition:background .2s,color .2s; }
.hm-drawer a:last-child { border-bottom:none; }
.hm-drawer a:hover { background:rgba(201,168,76,.1); color:var(--gold-lt); }
.hm-drawer-cta { margin-top:10px; text-align:center; background:var(--gold)!important; color:var(--navy)!important; font-weight:700!important; border-radius:100px!important; border-bottom:none!important; }
@media(max-width:900px){ .hm-nav-links,.hm-nav-cta{display:none;} .hm-burger{display:flex;} .hm-nav-inner{padding:0 16px;height:auto;min-height:64px;padding-top:10px;padding-bottom:10px;} }

/* HERO */
.hm-hero { position:relative; height:100vh; min-height:680px; display:flex; align-items:center; overflow:hidden; background:var(--navy); }
.hm-hero-img { position:absolute; inset:0; width:100%; height:100%; object-fit:cover; object-position:center top; opacity:.45; }
.hm-hero-overlay { position:absolute; inset:0; background:linear-gradient(105deg,rgba(10,25,49,.95) 35%,rgba(10,25,49,.4) 100%); }
.hm-hero-grid { position:absolute; inset:0; background-image:linear-gradient(rgba(201,168,76,.04) 1px,transparent 1px),linear-gradient(90deg,rgba(201,168,76,.04) 1px,transparent 1px); background-size:60px 60px; }
.hm-hero-content { position:relative; z-index:2; max-width:1280px; margin:0 auto; padding:0 40px; width:100%; display:grid; grid-template-columns:1fr 420px; gap:60px; align-items:center; }
@media(max-width:960px){ .hm-hero-content{grid-template-columns:1fr;padding:0 24px;} .hm-hero-aside{display:none;} }
.hm-hero-eyebrow { display:inline-flex; align-items:center; gap:10px; font-size:11px; font-weight:600; letter-spacing:3px; text-transform:uppercase; color:var(--gold); margin-bottom:20px; }
.hm-hero-eyebrow::before { content:''; display:block; width:32px; height:2px; background:var(--gold); }
.hm-hero h1 { font-family:'Playfair Display',serif; font-size:clamp(42px,6vw,76px); font-weight:900; line-height:1.06; color:#fff; margin-bottom:24px; }
.hm-hero h1 em { color:var(--gold); font-style:normal; }
.hm-hero-sub { font-size:17px; line-height:1.8; color:rgba(255,255,255,.65); max-width:500px; margin-bottom:40px; }
.hm-hero-btns { display:flex; gap:16px; flex-wrap:wrap; }
.hm-btn-gold { display:inline-flex; align-items:center; gap:8px; background:var(--gold); color:var(--navy); font-weight:700; font-size:15px; padding:16px 34px; border-radius:100px; border:none; cursor:pointer; text-decoration:none; transition:background .2s,transform .2s; font-family:'DM Sans',sans-serif; }
.hm-btn-gold:hover { background:var(--gold-lt); transform:translateY(-2px); }
.hm-btn-ghost { display:inline-flex; align-items:center; gap:8px; background:transparent; color:#fff; font-weight:600; font-size:15px; padding:14px 32px; border-radius:100px; border:2px solid rgba(255,255,255,.3); cursor:pointer; text-decoration:none; transition:border-color .2s,color .2s; font-family:'DM Sans',sans-serif; }
.hm-btn-ghost:hover { border-color:var(--gold); color:var(--gold); }
.hm-hero-dots { display:flex; gap:8px; margin-top:40px; }
.hm-hero-dot { width:32px; height:3px; border-radius:2px; background:rgba(255,255,255,.25); cursor:pointer; transition:background .3s,width .3s; border:none; }
.hm-hero-dot.active { background:var(--gold); width:56px; }
.hm-hero-aside { background:rgba(255,255,255,.06); border:1px solid rgba(201,168,76,.2); border-radius:20px; padding:32px; backdrop-filter:blur(12px); }
.hm-aside-title { font-family:'Playfair Display',serif; font-size:18px; font-weight:700; color:#fff; margin-bottom:20px; }
.hm-aside-stat { display:flex; align-items:center; gap:16px; padding:14px 0; border-bottom:1px solid rgba(255,255,255,.08); }
.hm-aside-stat:last-child { border-bottom:none; }
.hm-aside-num { font-family:'Playfair Display',serif; font-size:22px; font-weight:700; color:var(--gold); min-width:90px; }
.hm-aside-lbl { font-size:13px; color:rgba(255,255,255,.6); line-height:1.4; }

/* STATS */
.hm-stats { background:var(--navy); padding:60px 40px; }
.hm-stats-grid { max-width:1280px; margin:0 auto; display:grid; grid-template-columns:repeat(4,1fr); gap:2px; }
@media(max-width:768px){ .hm-stats-grid{grid-template-columns:repeat(2,1fr);} }
.hm-stat-item { text-align:center; padding:40px 20px; border-right:1px solid rgba(201,168,76,.15); }
.hm-stat-item:last-child { border-right:none; }
.hm-stat-num { font-family:'Playfair Display',serif; font-size:clamp(40px,5vw,64px); font-weight:900; color:var(--gold); display:block; line-height:1; }
.hm-stat-sup { font-size:.5em; vertical-align:super; }
.hm-stat-lbl { font-size:12px; letter-spacing:2px; text-transform:uppercase; color:rgba(255,255,255,.5); margin-top:10px; display:block; }

/* SHARED */
.hm-section { padding:100px 40px; background:#fff; }
@media(max-width:768px){ .hm-section{padding:64px 20px;} }
.hm-container { max-width:1280px; margin:0 auto; }
.hm-label { display:inline-flex; align-items:center; gap:10px; font-size:11px; font-weight:600; letter-spacing:3px; text-transform:uppercase; color:var(--gold); margin-bottom:12px; }
.hm-label::before { content:''; display:block; width:24px; height:2px; background:var(--gold); }
.hm-title { font-family:'Playfair Display',serif; font-size:clamp(30px,4vw,46px); font-weight:700; line-height:1.15; color:var(--navy); margin-bottom:14px; }
.hm-title-white { color:#fff!important; }
.hm-desc { font-size:17px; line-height:1.8; color:var(--gray); max-width:560px; }
.hm-desc-white { color:rgba(255,255,255,.65)!important; }
.hm-center { text-align:center; }
.hm-center .hm-label { justify-content:center; }
.hm-center .hm-desc { margin:0 auto; }
.hm-gold-line { width:56px; height:3px; background:var(--gold); border-radius:2px; margin:20px 0 48px; }
.hm-gold-line-center { margin:20px auto 48px; }
.hm-fade { opacity:0; transform:translateY(28px); transition:opacity .65s ease,transform .65s ease; }
.hm-fade.in { opacity:1; transform:none; }

/* LEADERSHIP MESSAGES */
.hm-leadership { background:#fff; }
.hm-leader-grid { display:grid; grid-template-columns:repeat(3,1fr); gap:28px; margin-top:56px; }
@media(max-width:900px){ .hm-leader-grid{grid-template-columns:1fr;} }
.hm-leader-card { background:#fff; border-radius:20px; overflow:hidden; box-shadow:0 8px 40px rgba(10,25,49,.08); transition:transform .3s,box-shadow .3s; border:1px solid var(--gray-lt); }
.hm-leader-card:hover { transform:translateY(-8px); box-shadow:0 24px 80px rgba(10,25,49,.15); }
.hm-leader-head { background:linear-gradient(135deg,var(--navy),var(--blue)); padding:32px 24px 20px; text-align:center; position:relative; }
.hm-leader-head::after { content:''; position:absolute; bottom:-1px; left:0; right:0; height:40px; background:#fff; clip-path:ellipse(55% 100% at 50% 100%); }
.hm-leader-photo { width:92px; height:92px; border-radius:50%; border:4px solid var(--gold); object-fit:cover; display:block; margin:0 auto 12px; position:relative; z-index:1; }
.hm-leader-name { font-family:'Playfair Display',serif; font-size:18px; font-weight:700; color:#fff; position:relative; z-index:1; }
.hm-leader-role { font-size:11px; letter-spacing:2px; text-transform:uppercase; color:var(--gold); margin-top:4px; position:relative; z-index:1; }
.hm-leader-body { padding:28px 24px 24px; }
.hm-leader-quote { font-size:14px; line-height:1.8; color:var(--gray); font-style:italic; padding-left:14px; border-left:3px solid var(--gold); margin-bottom:18px; }
.hm-leader-btn { font-size:13px; font-weight:600; color:var(--navy); background:none; border:none; cursor:pointer; padding:0; transition:color .2s; font-family:'DM Sans',sans-serif; }
.hm-leader-btn:hover { color:var(--gold); }

/* ORG */
.hm-org { background:var(--navy); }
.hm-org-tabs { display:flex; background:rgba(255,255,255,.05); border:1px solid rgba(201,168,76,.2); border-radius:100px; padding:5px; width:fit-content; margin:0 auto 52px; }
.hm-org-tab { padding:11px 26px; border-radius:100px; font-size:13px; font-weight:600; letter-spacing:.5px; color:rgba(255,255,255,.5); background:none; border:none; cursor:pointer; transition:all .25s; font-family:'DM Sans',sans-serif; white-space:nowrap; }
.hm-org-tab.active { background:var(--gold); color:var(--navy); }
@media(max-width:700px){ .hm-org-tabs{flex-direction:column;border-radius:16px;width:100%;} .hm-org-tab{border-radius:12px;text-align:center;} }
.hm-founder-slide { display:flex; flex-direction:column; align-items:center; text-align:center; }
.hm-founder-photo-wrap { position:relative; margin-bottom:28px; }
.hm-founder-photo { width:160px; height:160px; border-radius:50%; object-fit:contain; background:var(--navy); border:4px solid var(--gold); box-shadow:0 0 0 10px rgba(201,168,76,.12),0 20px 60px rgba(0,0,0,.4); display:block; }
.hm-founder-badge { position:absolute; bottom:6px; right:6px; width:38px; height:38px; border-radius:50%; background:var(--gold); border:3px solid var(--navy); display:flex; align-items:center; justify-content:center; font-size:18px; }
.hm-founder-name { font-family:'Playfair Display',serif; font-size:clamp(24px,4vw,38px); font-weight:900; color:#fff; margin-bottom:8px; }
.hm-founder-role { font-size:12px; font-weight:600; letter-spacing:3px; text-transform:uppercase; color:var(--gold); margin-bottom:20px; }
.hm-founder-desc { font-size:16px; line-height:1.9; color:rgba(255,255,255,.6); max-width:600px; margin:0 auto 28px; }
.hm-founder-link { display:inline-flex; align-items:center; gap:8px; background:var(--gold); color:var(--navy); font-weight:700; font-size:14px; padding:13px 28px; border-radius:100px; text-decoration:none; transition:background .2s,transform .2s; font-family:'DM Sans',sans-serif; }
.hm-founder-link:hover { background:var(--gold-lt); transform:translateY(-2px); }
.hm-board-grid { display:grid; gap:24px; grid-template-columns:repeat(auto-fit,minmax(200px,1fr)); }
.hm-board-card { background:rgba(255,255,255,.05); border:1px solid rgba(201,168,76,.18); border-radius:20px; overflow:hidden; text-align:center; transition:transform .3s,background .3s,border-color .3s; text-decoration:none; display:block; cursor:pointer; }
.hm-board-card:hover { transform:translateY(-7px); background:rgba(201,168,76,.07); border-color:rgba(201,168,76,.4); }
.hm-board-img-wrap { width:100%; height:240px; overflow:hidden; position:relative; background:var(--navy); }
.hm-board-img-wrap img { width:100%; height:100%; object-fit:contain; display:block; transition:transform .5s; }
.hm-board-card:hover .hm-board-img-wrap img { transform:scale(1.04); }
.hm-board-img-overlay { position:absolute; inset:0; background:linear-gradient(180deg,transparent 50%,rgba(10,25,49,.6) 100%); }
.hm-board-avatar-wrap { width:100%; height:240px; background:linear-gradient(135deg,var(--blue),#0d2550); display:flex; align-items:center; justify-content:center; }
.hm-board-avatar { width:80px; height:80px; border-radius:50%; background:rgba(255,255,255,.08); border:2px solid var(--gold); display:flex; align-items:center; justify-content:center; font-family:'Playfair Display',serif; font-size:26px; font-weight:700; color:var(--gold); }
.hm-board-body { padding:18px 16px 20px; }
.hm-board-name { font-family:'Playfair Display',serif; font-size:15px; font-weight:700; color:#fff; margin-bottom:6px; }
.hm-board-title { font-size:11px; letter-spacing:1.5px; text-transform:uppercase; color:var(--gold); margin-bottom:10px; }
.hm-board-read { font-size:12px; font-weight:600; color:rgba(255,255,255,.45); display:inline-flex; align-items:center; gap:4px; transition:color .2s; }
.hm-board-card:hover .hm-board-read { color:var(--gold); }

/* FACULTY */
.hm-faculty-section { background:var(--light); }
.hm-faculty-grid { display:grid; grid-template-columns:repeat(auto-fill,minmax(200px,1fr)); gap:22px; margin-top:56px; }
@media(max-width:480px){ .hm-faculty-grid{grid-template-columns:1fr 1fr;gap:12px;} }
.hm-fac-card { background:#fff; border-radius:18px; overflow:hidden; box-shadow:0 4px 24px rgba(10,25,49,.07); transition:transform .3s,box-shadow .3s; text-decoration:none; display:block; cursor:pointer; border:1px solid var(--gray-lt); }
.hm-fac-card:hover { transform:translateY(-7px); box-shadow:0 20px 60px rgba(10,25,49,.14); }
.hm-fac-photo-strip { width:100%; height:200px; overflow:hidden; position:relative; background:var(--navy); }
.hm-fac-photo-strip img { width:100%; height:100%; object-fit:contain; display:block; transition:transform .5s; }
.hm-fac-card:hover .hm-fac-photo-strip img { transform:scale(1.04); }
.hm-fac-photo-strip-overlay { position:absolute; inset:0; background:linear-gradient(180deg,transparent 60%,rgba(10,25,49,.65) 100%); }
.hm-fac-head { background:linear-gradient(135deg,var(--navy),var(--blue)); padding:28px 20px 18px; text-align:center; position:relative; }
.hm-fac-head::after { content:''; position:absolute; bottom:-1px; left:0; right:0; height:36px; background:#fff; clip-path:ellipse(55% 100% at 50% 100%); }
.hm-fac-avatar { width:72px; height:72px; border-radius:50%; background:rgba(255,255,255,.12); border:3px solid var(--gold); display:flex; align-items:center; justify-content:center; margin:0 auto 10px; position:relative; z-index:1; font-family:'Playfair Display',serif; font-size:24px; font-weight:700; color:var(--gold); }
.hm-fac-name { font-family:'Playfair Display',serif; font-size:14px; font-weight:700; color:#fff; position:relative; z-index:1; }
.hm-fac-sub { font-size:10px; letter-spacing:1.5px; text-transform:uppercase; color:var(--gold); margin-top:3px; position:relative; z-index:1; }
.hm-fac-body { padding:18px 16px 20px; }
.hm-fac-tag { display:inline-block; font-size:10px; font-weight:600; letter-spacing:1px; text-transform:uppercase; color:var(--gold); background:rgba(201,168,76,.1); padding:3px 10px; border-radius:100px; margin-bottom:8px; }
.hm-fac-arrow { font-size:12px; color:var(--gray); display:flex; align-items:center; gap:5px; transition:color .2s; }
.hm-fac-card:hover .hm-fac-arrow { color:var(--gold); }
.hm-fac-view-all { text-align:center; margin-top:44px; }

/* EVENTS */
.hm-events { background:var(--light); }
.hm-events-grid { display:grid; grid-template-columns:repeat(3,1fr); gap:24px; margin-top:56px; }
@media(max-width:900px){ .hm-events-grid{grid-template-columns:1fr 1fr;} }
@media(max-width:560px){ .hm-events-grid{grid-template-columns:1fr;} }
.hm-event-card { background:#fff; border-radius:16px; overflow:hidden; box-shadow:0 4px 24px rgba(10,25,49,.07); transition:transform .3s,box-shadow .3s; border:1px solid var(--gray-lt); }
.hm-event-card:hover { transform:translateY(-6px); box-shadow:0 20px 60px rgba(10,25,49,.13); }
.hm-event-img { width:100%; height:200px; object-fit:cover; display:block; }
.hm-event-body { padding:20px; }
.hm-event-tag { display:inline-block; font-size:10px; font-weight:600; letter-spacing:1.5px; text-transform:uppercase; color:var(--gold); background:rgba(201,168,76,.1); padding:3px 10px; border-radius:100px; margin-bottom:10px; }
.hm-event-title { font-family:'Playfair Display',serif; font-size:18px; font-weight:700; color:var(--navy); margin-bottom:6px; }
.hm-event-desc { font-size:14px; color:var(--gray); line-height:1.6; }

/* ── ALUMNI — NEW CARD STYLE ── */
.hm-alumni { background:var(--navy); padding:100px 40px; }
@media(max-width:768px){ .hm-alumni{padding:64px 20px;} }
.hm-alumni-scroll-wrap { overflow-x:auto; padding-bottom:16px; margin-top:56px; scrollbar-width:thin; scrollbar-color:var(--gold) rgba(255,255,255,.1); }
.hm-alumni-scroll-wrap::-webkit-scrollbar { height:4px; }
.hm-alumni-scroll-wrap::-webkit-scrollbar-track { background:rgba(255,255,255,.08); border-radius:2px; }
.hm-alumni-scroll-wrap::-webkit-scrollbar-thumb { background:var(--gold); border-radius:2px; }
.hm-alumni-grid { display:grid; grid-template-columns:repeat(4,1fr); gap:20px; }
@media(max-width:1100px){ .hm-alumni-grid{grid-template-columns:repeat(3,1fr);} }
@media(max-width:768px){ .hm-alumni-grid{grid-template-columns:repeat(2,1fr);gap:14px;} }
@media(max-width:460px){ .hm-alumni-grid{grid-template-columns:1fr 1fr;gap:12px;} }

.hm-alum-card {
  background:rgba(255,255,255,.05);
  border:1px solid rgba(201,168,76,.15);
  border-radius:18px;
  padding:24px 18px 20px;
  text-align:center;
  transition:transform .3s,background .3s,border-color .3s;
  display:flex; flex-direction:column; align-items:center; gap:10px;
}
.hm-alum-card:hover { transform:translateY(-6px); background:rgba(201,168,76,.07); border-color:rgba(201,168,76,.35); }

.hm-alum-avatar {
  width:72px; height:72px; border-radius:50%;
  background:linear-gradient(135deg,var(--blue),#0d2550);
  border:3px solid var(--gold);
  display:flex; align-items:center; justify-content:center;
  font-family:'Playfair Display',serif;
  font-size:22px; font-weight:700; color:var(--gold);
  flex-shrink:0;
  box-shadow:0 0 0 6px rgba(201,168,76,.1);
}
.hm-alum-photo {
  width:72px; height:72px; border-radius:50%;
  object-fit:cover; display:block;
  border:3px solid var(--gold);
  box-shadow:0 0 0 6px rgba(201,168,76,.1);
}
.hm-alum-name {
  font-family:'Playfair Display',serif;
  font-size:15px; font-weight:700; color:#fff;
  line-height:1.2;
}
.hm-alum-role-badge {
  display:inline-flex; align-items:center; gap:5px;
  font-size:11px; font-weight:600;
  letter-spacing:.5px;
  color:var(--gold);
  background:rgba(201,168,76,.12);
  border:1px solid rgba(201,168,76,.25);
  padding:4px 12px; border-radius:100px;
  line-height:1.3;
}
.hm-alum-icon { font-size:13px; }

/* CTA */
.hm-cta { background:linear-gradient(105deg,var(--navy) 0%,#112550 100%); padding:100px 40px; position:relative; overflow:hidden; }
.hm-cta::before { content:''; position:absolute; inset:0; background:radial-gradient(circle at 80% 50%,rgba(201,168,76,.1),transparent 50%); }
.hm-cta-inner { max-width:1280px; margin:0 auto; display:grid; grid-template-columns:1fr auto; gap:48px; align-items:center; position:relative; z-index:1; }
@media(max-width:768px){ .hm-cta-inner{grid-template-columns:1fr;} }
.hm-cta-title { font-family:'Playfair Display',serif; font-size:clamp(30px,4vw,48px); font-weight:900; color:#fff; line-height:1.15; margin-bottom:12px; }
.hm-cta-title em { color:var(--gold); font-style:normal; }
.hm-cta-sub { font-size:16px; color:rgba(255,255,255,.6); }
.hm-cta-btns { display:flex; gap:14px; flex-wrap:wrap; }

/* FOOTER */
.hm-footer { background:#060f1e; padding:60px 40px 30px; }
.hm-footer-inner { max-width:1280px; margin:0 auto; display:grid; grid-template-columns:2fr 1fr 1fr; gap:60px; padding-bottom:48px; border-bottom:1px solid rgba(255,255,255,.08); }
@media(max-width:768px){ .hm-footer-inner{grid-template-columns:1fr;gap:36px;} }
.hm-footer-brand-name { font-family:'Playfair Display',serif; font-size:20px; font-weight:700; color:#fff; margin-bottom:12px; }
.hm-footer-brand-desc { font-size:14px; color:rgba(255,255,255,.45); line-height:1.7; margin-bottom:24px; }
.hm-footer-social { display:flex; gap:12px; }
.hm-footer-social-btn { width:36px; height:36px; border:1px solid rgba(255,255,255,.15); border-radius:50%; display:flex; align-items:center; justify-content:center; color:rgba(255,255,255,.5); text-decoration:none; font-size:14px; transition:border-color .2s,color .2s; }
.hm-footer-social-btn:hover { border-color:var(--gold); color:var(--gold); }
.hm-footer-col-title { font-size:12px; font-weight:600; letter-spacing:2px; text-transform:uppercase; color:var(--gold); margin-bottom:20px; }
.hm-footer-links { list-style:none; display:flex; flex-direction:column; gap:10px; }
.hm-footer-links a { font-size:14px; color:rgba(255,255,255,.5); text-decoration:none; transition:color .2s; }
.hm-footer-links a:hover { color:var(--gold-lt); }
.hm-footer-bottom { max-width:1280px; margin:0 auto; padding-top:28px; display:flex; justify-content:space-between; align-items:center; flex-wrap:wrap; gap:12px; }
.hm-footer-copy { font-size:12px; color:rgba(255,255,255,.25); }
.hm-footer-credit {
  font-size:12px;
  font-style:italic;
  color:var(--gold);
  letter-spacing:.5px;
  position:relative;
  display:inline-flex;
  align-items:center;
  gap:6px;
}
.hm-footer-credit::before {
  content:'✦';
  font-style:normal;
  font-size:10px;
  color:rgba(201,168,76,.5);
}
`;

/* ─── DATA ─── */
const heroSlides = [
  { heading:['Shaping','Future','Leaders'],  sub:'At Dr A.Q. Khan College, we deliver quality education that empowers students with knowledge, confidence, and skills to excel in life.', img:heroImg1 },
  { heading:['Excellence','in','Education'], sub:'Our experienced faculty and modern learning environment ensure every student reaches their full potential.', img:heroImg2 },
  { heading:['Building','Bright','Futures'], sub:"We nurture creativity, discipline, and leadership to prepare students for tomorrow's challenges.", img:heroImg3 },
];

export const leadershipData = [
  { id:'founder', name:'Dr. Abdul Qadeer Khan', role:'Founder & National Hero of Pakistan', photo:founderImg, badge:'🇵🇰', category:'Founder', message:`Dr. Abdul Qadeer Khan was not only a scientist of extraordinary stature but a man whose heart beat for Pakistan. His dream was simple yet profound: to ensure that every Pakistani child has access to world-class education — the true foundation of national strength.\n\nHis vision in establishing this institution was to create a place where young minds are not just taught, but inspired. Where knowledge meets character, and where students leave not only as scholars but as responsible citizens ready to serve their nation.\n\nHis legacy lives on in every student who walks these halls, in every teacher who imparts wisdom, and in every family whose child's future is brighter because of this college.` },
  { id:'ceo', name:'Dr. G.Q. Mohsin', role:'Chief Executive Officer', photo:ceoImg1, badge:'🏛️', category:'CEO', message:`At Dr. A.Q. Khan College, we are dedicated to revolutionizing the dynamics of the education sector — a place where education thrives beyond boundaries.` },
  { id:'shireen', name:"Ma'am Shireen", role:'Board of Directors', photo:mamShireen, badge:'📋', category:'Board of Directors', message:`Education is the most powerful tool we can give our children.` },
  { id:'najaf', name:'Dr. Najaf Ali Mohsin', role:'Board of Directors', photo:directorImg, badge:'📋', category:'Board of Directors', message:`Excellence in education requires vision, strategy, and an unwavering commitment to continuous improvement.` },
  { id:'rashid', name:'Rashid Minhas', role:'Board of Directors', photo:sirRashid, badge:'📋', category:'Board of Directors', message:`Serving on the Board of Directors is both an honour and a responsibility I carry with deep conviction.` },
  { id:'hafsa', name:"Ma'am Hafsa", role:'Board of Governors', photo:mamHafsa, badge:'🏛️', category:'Board of Governors', message:`As a member of the Board of Governors, my deepest concern is the holistic wellbeing of our students.` },
  { id:'anum', name:"Ma'am Anum", role:'Board of Governors', photo:mamAnum, badge:'🏛️', category:'Board of Governors', message:`Education without character is incomplete. That is the philosophy that drives the Board of Governors.` },
  { id:'aqeel', name:'Prof. Aqeel Gul', role:'Board of Governors', photo:profAqeel, badge:'🏛️', category:'Board of Governors', message:`When I look at our students, I see the future of Pakistan.` },
  { id:'amjad', name:'Prof. Amjad Qureshi', role:'Board of Governors', photo:sirAmjad, badge:'🏛️', category:'Board of Governors', message:`Governance in education is ultimately about one thing: ensuring every student gets the opportunity they deserve.` },
];

export const facultyData = [
  { id:1,  name:'Ms. Sadia',       subject:'Accounting & Finance', experience:'8+ Years',  qual:'MS Finance',                                    gender:'female', photo:mamSadia    },    
  { id:2,  name:'Ms. Faiza',       subject:'Humanities',           experience:'10+ Years', qual:'Bachelor of Arts',                              gender:'female', photo:mamFaiza    },
  { id:3,  name:'Sir Safdar',      subject:'I.Com',                experience:'7+ Years',  qual:'M.Sc. Statistics',                              gender:'male',   photo:null        },
  { id:4,  name:'Sir Arslan',      subject:'English',              experience:'18+ Years', qual:'Masters in English',                            gender:'male',   photo:sirArslan   },     
  { id:5,  name:'Sir Sikandar',    subject:'Academic Incharge',    experience:'2+ Years',  qual:'BS Artificial Intelligence',                    gender:'male',   photo:sirSikander },
  { id:6,  name:'Sir Abdul Rafay', subject:'Marketing Manager',    experience:'2+ Years',  qual:'BS Law, Law College Rawalpindi',                gender:'male',   photo:sirRafay    },
  { id:7,  name:'Ms. Batool',      subject:'Biology',              experience:'7+ Years',  qual:'M.Sc. Microbiology',                            gender:'female', photo:mamBatool   },
  { id:8,  name:'Ms. Ramsha',      subject:'Biology',              experience:'8+ Years',  qual:'B.Sc. Biology',                                 gender:'female', photo:mamRamsha   },    
  { id:9,  name:'Ms. Taskeen',     subject:'Academic Incharge',    experience:'2+ Years',  qual:'BS BioChemistry',                      gender:'female', photo:msTaskeen       },
  { id:10, name:'Mrs. Nazim',      subject:'Tarjamat-ul-Quran',    experience:'2+ Years',  qual:'MA Islamiat',                                   gender:'female', photo:null        },
  { id:11, name:'Sir Arbab',       subject:'Mathematics',          experience:'4+ Years',  qual:'M.Sc. Mathematics, CUST',                       gender:'male',   photo:sirArbab        },
  { id:12, name:'Sir Daniyal',     subject:'Computer Science',     experience:'7+ Years',  qual:'BS Computer Science, AIR University',           gender:'male',   photo:sirDaniyal  },
  { id:13, name:'Sir Ghazanfar',      subject:'Chemistry',            experience:'7+ Years',  qual:'MS Chemistry, University of Punjab',            gender:'male',   photo:sirGhazanfar   },
  { id:14, name:'Mam ShehrBano',   subject:'Psychology',            experience:'5+ Years',  qual:'Mphil professional psychology bahria university',            gender:'female', photo:mamShehrBano },
    { id:15, name:'Sir Abdul Basit ',     subject:'Computer Science',     experience:'10+ Years',  qual:'Masters in Computer Science, AIR University',           gender:'male',   photo:null  },
{ id:16, name:'Sir Nadeem',   subject:'Physics',            experience:'7+ Years',  qual:'Masters in Physics, University of Punjab',            gender:'male', photo:sirNadeem  },
{ id:17, name:'Sir Ahsan Kabir',   subject:'Islamic Studies',            experience:'3+ Years',  qual:'Bachelors in Islamic Studies, Islamia University Lahore',            gender:'male', photo:sirAhsan  },
];

// role icons mapped by profession keyword
const roleIcon = (role) => {
  const r = role.toLowerCase();
  if(r.includes('army') || r.includes('military')) return '';
  if(r.includes('doctor') || r.includes('mbbs') || r.includes('pharmacy') || r.includes('nursing')) return '';
  if(r.includes('engineer')) return '';
  if(r.includes('hockey') || r.includes('sport')) return '';
  if(r.includes('police')) return '';
  if(r.includes('advocate') || r.includes('law')) return '';
  if(r.includes('account') || r.includes('chartered')) return '';
  if(r.includes('ai') || r.includes('artificial') || r.includes('data')) return '';
  if(r.includes('web') || r.includes('developer')) return '';
  if(r.includes('nutrition')) return '';
  if(r.includes('examination') || r.includes('incharge')) return '';
  if(r.includes('aeronautical')) return '';
  return '';
};

const alumniData = [
  { name:'Saman Naqeeb',       role:'Nutritionist'                          },
  { name:'Adnan',               role:'National Hockey Player'                },
  { name:'Faha',                role:'Army Nursing'                          },
  { name:'Zain Bin Ishaq',      role:'Pakistan Army'                         },
  { name:'Zaib Fatima',         role:'Web Developer'                         },
  { name:'Umama Javed',         role:'Cyber Security Specialist'             },
  { name:'MahFazia Bhatti',        role:'Technical Instructor'              },
  { name:'Abdul Ahad',          role:'Punjab Police'                         },
  { name:'Ubaid',               role:'Mechanical Engineer'                   },
  { name:'Ismail Ijaz',         role:'Doctor of Pharmacy'                    },
  { name:'Huzaifa Hashimi',     role:'Chartered Accountant'                  },
  { name:'Zaib Fatima',         role:'Web Developer'                         },
  { name:'Amna Shehzad',        role:'Advocate'                              },
  { name:'Kaneez Fatima',       role:'Data Scientist'                        },
  { name:'Ibrahim Qaisar',      role:'Aeronautical Engineer'                 },
  { name:'Emaan Tahir',         role:'MBBS'                                  },
];

const eventsData = [
  { img:event1, tag:'Academic',  title:'Career Counselling',    desc:'Expert-led sessions guiding students toward their ideal career paths.' },
  { img:event2, tag:'Trips',     title:'Outdoor Trip',          desc:'Exciting day out for Boys Campus — learning beyond the classroom.' },
  { img:event3, tag:'Trips',     title:'IST University Visit',  desc:'Girls Campus tour of IST University for higher-education insight.' },
  { img:event4, tag:'Sports',    title:'Civil Work Fare',       desc:"Students participate in community welfare and civil engagement activities." },
  { img:event5, tag:'Sports',    title:'Sports Gala',           desc:'Inter-campus sporting extravaganza celebrating student athleticism.' },
  { img:event6, tag:'Cultural',  title:'Iqbal Day Ceremony',    desc:'Tribute to the national poet with recitations, speeches, and performances.' },
];

const leaderMessages = [
  {
    id:'founder',
    title:'Founder',
    role:'Dr. Abdul Qadeer Khan',
    img:founderImg,
    short:'His vision was to ensure that every Pakistani child has access to world-class education — the true foundation of national strength.',
    full:'Dr. Abdul Qadeer Khan was not only a scientist of extraordinary stature but a man whose heart beat for Pakistan. His dream was simple yet profound: to ensure that every Pakistani child has access to world-class education — the true foundation of national strength.\n\nHis vision in establishing this institution was to create a place where young minds are not just taught, but inspired. Where knowledge meets character, and where students leave not only as scholars but as responsible citizens ready to serve their nation.\n\nHis legacy lives on in every student who walks these halls, in every teacher who imparts wisdom, and in every family whose child\'s future is brighter because of this college.',
  },
  {
    id:'ceo',
    title:'Director',
    role:'Dr. Najaf Ali Mohsin',
    img:directorImg,
    short:'We are dedicated to revolutionizing education beyond boundaries, fostering creativity, confidence, and holistic growth.',
    full:'At Dr. AQ Khan College, we are dedicated to revolutionizing the dynamics of the education sector, where education thrives beyond boundaries. We foster creativity, confidence, and holistic growth in our students. Our aim is to develop well-rounded individuals empowering them with purpose, integrity, and social responsibility.',
  },
  {
    id:'principal',
    title:"Principal",
    role:'Mam Anum',
    img:mamAnum,
    short:'Education without character is incomplete. We nurture every student not just academically but as a complete human being.',
    full:"Education without character is incomplete. That is the philosophy that drives the Board of Governors at Dr. A.Q. Khan College, and it is the philosophy I carry in every decision I make on behalf of our students.\n\nWe are working tirelessly to improve student support systems, enhance our co-curricular activities, and ensure that every student — regardless of background — has access to the best education possible.\n\nThis institution is more than a college. It is a community, and I am honoured to serve it.",
  },
];

const orgTabs = ['Founder','CEO','Board of Directors','Board of Governors'];
const boardDirectors = leadershipData.filter(p => p.category === 'Board of Directors');
const boardGovernors = leadershipData.filter(p => p.category === 'Board of Governors');

function useFade() {
  useEffect(() => {
    const els = document.querySelectorAll('.hm-fade');
    const obs = new IntersectionObserver(
      entries => entries.forEach(e => { if(e.isIntersecting){ e.target.classList.add('in'); obs.unobserve(e.target); } }),
      { threshold:0.1 }
    );
    els.forEach(el => obs.observe(el));
    return () => obs.disconnect();
  }, []);
}

function BoardCard({ person }) {
  const initials = person.name.replace(/[^a-zA-Z\s]/g,'').split(' ').filter(w=>w.length>1).map(w=>w[0]).slice(0,2).join('');
  return (
    <Link to={`/leadership/${person.id}`} className="hm-board-card">
      {person.photo ? (
        <div className="hm-board-img-wrap"><img src={person.photo} alt={person.name}/><div className="hm-board-img-overlay"/></div>
      ) : (
        <div className="hm-board-avatar-wrap"><div className="hm-board-avatar">{initials}</div></div>
      )}
      <div className="hm-board-body">
        <div className="hm-board-name">{person.name}</div>
        <div className="hm-board-title">{person.role}</div>
        <span className="hm-board-read">Read Message →</span>
      </div>
    </Link>
  );
}

function FacCard({ f, i }) {
  const initials = f.name.split(' ').filter(w=>w.length>1).map(w=>w[0]).slice(0,2).join('');
  return (
    <Link to={`/faculty#${f.id}`} className="hm-fac-card hm-fade" style={{transitionDelay:`${i*.06}s`}}>
      {f.photo ? (
        <div style={{position:'relative'}}>
          <div className="hm-fac-photo-strip"><img src={f.photo} alt={f.name}/><div className="hm-fac-photo-strip-overlay"/></div>
          <div style={{background:'linear-gradient(135deg,#0A1931,#1A3A6E)',padding:'10px 12px 18px',textAlign:'center',position:'relative'}}>
            <div className="hm-fac-name">{f.name}</div>
            <div className="hm-fac-sub">{f.subject}</div>
          </div>
          <div style={{position:'absolute',bottom:'-1px',left:0,right:0,height:36,background:'#fff',clipPath:'ellipse(55% 100% at 50% 100%)',zIndex:2}}/>
        </div>
      ) : (
        <div className="hm-fac-head">
          <div className="hm-fac-avatar">{initials}</div>
          <div className="hm-fac-name">{f.name}</div>
          <div className="hm-fac-sub">{f.subject}</div>
        </div>
      )}
      <div className="hm-fac-body">
        <span className="hm-fac-tag">{f.subject}</span>
        <div className="hm-fac-arrow">View Full Profile →</div>
      </div>
    </Link>
  );
}

function AlumCard({ al, i }) {
  const initials = al.name.split(' ').map(w=>w[0]).slice(0,2).join('').toUpperCase();
  return (
    <div className="hm-alum-card hm-fade" style={{transitionDelay:`${i*.04}s`}}>
      {al.photo
        ? <img src={al.photo} alt={al.name} className="hm-alum-photo"/>
        : <div className="hm-alum-avatar">{initials}</div>
      }
      <div className="hm-alum-name">{al.name}</div>
      <div className="hm-alum-role-badge">
        <span className="hm-alum-icon">{roleIcon(al.role)}</span>
        {al.role}
      </div>
    </div>
  );
}

export default function Home() {
  const [slide, setSlide]                   = useState(0);
  const [counts, setCounts]                 = useState({ s:0,p:0,f:0,m:0 });
  const [orgTab, setOrgTab]                 = useState(0);
  const [expandedLeader, setExpandedLeader] = useState(null);
  const [menuOpen, setMenuOpen]             = useState(false);
  useFade();

  useEffect(() => {
    const id = setInterval(() => setSlide(s => (s+1) % heroSlides.length), 5500);
    return () => clearInterval(id);
  }, []);

  useEffect(() => {
    const targets = { s:500,p:8,f:30,m:3 };
    let step=0; const steps=60; const dur=2000;
    const id = setInterval(() => {
      step++;
      const prog = step/steps;
      setCounts({ s:Math.round(targets.s*prog), p:Math.round(targets.p*prog), f:Math.round(targets.f*prog), m:Math.round(targets.m*prog) });
      if(step>=steps) clearInterval(id);
    }, dur/steps);
    return () => clearInterval(id);
  }, []);

  const countsArr = [
    { num:counts.s, sup:'+', lbl:'Students Enrolled' },
    { num:counts.p, sup:'',  lbl:'Programs Offered' },
    { num:counts.f, sup:'+', lbl:'Expert Faculty' },
    { num:counts.m, sup:'',  lbl:'University MOUs' },
  ];

  const closeMenu = () => setMenuOpen(false);

  return (
    <>
      <style>{css}</style>
      <div className="hm">

        {/* NAV */}
        <nav className="hm-nav">
          <div className="hm-nav-inner">
            <span style={{fontFamily:"'Playfair Display',serif",fontSize:18,fontWeight:700,color:'var(--gold)',letterSpacing:.5,flexShrink:0}}>
              Dr. A.Q. Khan College
            </span>
            <ul className="hm-nav-links">
              {[['Home','/'],['About','/about'],['Admissions','/admissions'],['Faculty','/faculty'],['Leadership','/leadership'],['Contact','/contact']].map(([l,p])=>(
                <li key={p}><Link to={p}>{l}</Link></li>
              ))}
            </ul>
            <Link to="/admissions" className="hm-nav-cta">Get Admission Form</Link>
            <button className={`hm-burger${menuOpen?' open':''}`} onClick={()=>setMenuOpen(v=>!v)} aria-label="Menu">
              <span/><span/><span/>
            </button>
          </div>
          <div className={`hm-drawer${menuOpen?' visible':''}${menuOpen?' open':''}`}>
            {[['🏠 Home','/'],['📖 About','/about'],['🎓 Admissions','/admissions'],['👨‍🏫 Faculty','/faculty'],['🏛️ Leadership','/leadership'],['📞 Contact','/contact']].map(([l,p])=>(
              <Link key={p} to={p} onClick={closeMenu}>{l}</Link>
            ))}
            <Link to="/admissions" className="hm-drawer-cta" onClick={closeMenu}>📄 Get Admission Form</Link>
          </div>
        </nav>

        {/* HERO */}
        <section className="hm-hero">
          <AnimatePresence mode="wait">
            <motion.img key={slide} src={heroSlides[slide].img} className="hm-hero-img"
              initial={{opacity:0,scale:1.06}} animate={{opacity:.45,scale:1}} exit={{opacity:0}} transition={{duration:1.2}}/>
          </AnimatePresence>
          <div className="hm-hero-overlay"/><div className="hm-hero-grid"/>
          <div className="hm-hero-content">
            <div>
              <div className="hm-hero-eyebrow">Rawalpindi · Harley Street</div>
              <AnimatePresence mode="wait">
                <motion.h1 key={slide} initial={{opacity:0,y:30}} animate={{opacity:1,y:0}} exit={{opacity:0,y:-20}} transition={{duration:.7}}>
                  {heroSlides[slide].heading[0]} <em>{heroSlides[slide].heading[1]}</em> {heroSlides[slide].heading[2]}
                </motion.h1>
              </AnimatePresence>
              <AnimatePresence mode="wait">
                <motion.p key={`s-${slide}`} className="hm-hero-sub"
                  initial={{opacity:0}} animate={{opacity:1}} exit={{opacity:0}} transition={{duration:.6,delay:.15}}>
                  {heroSlides[slide].sub}
                </motion.p>
              </AnimatePresence>
              <div className="hm-hero-btns">
                <Link to="/admissions" className="hm-btn-gold">Get Admission Form</Link>
                <Link to="/about" className="hm-btn-ghost">Explore Programs</Link>
              </div>
              <div className="hm-hero-dots">
                {heroSlides.map((_,i)=><button key={i} className={`hm-hero-dot${slide===i?' active':''}`} onClick={()=>setSlide(i)}/>)}
              </div>
            </div>
            <div className="hm-hero-aside">
              <div className="hm-aside-title">At a Glance</div>
              {[{num:'8+',lbl:'Programs — FSc, ICS, ICOM, FA'},{num:'6',lbl:'University MOUs — Riphah,CUST, IST, ATH, BIIT, University of Rawalpindi'},{num:'80%+',lbl:'Scholarships for top students'},{num:'NAVTTC & FBISE',lbl:'Affiliated'}].map((s,i)=>(
                <div key={i} className="hm-aside-stat">
                  <span className="hm-aside-num">{s.num}</span>
                  <span className="hm-aside-lbl">{s.lbl}</span>
                </div>
              ))}
            </div>
          </div>
        </section>

        {/* STATS */}
        <div className="hm-stats">
          <div className="hm-stats-grid">
            {countsArr.map((s,i)=>(
              <div key={i} className="hm-stat-item">
                <span className="hm-stat-num">{s.num}<span className="hm-stat-sup">{s.sup}</span></span>
                <span className="hm-stat-lbl">{s.lbl}</span>
              </div>
            ))}
          </div>
        </div>

        {/* LEADERSHIP MESSAGES */}
        <section className="hm-section hm-leadership">
          <div className="hm-container">
            <div className="hm-center hm-fade">
              <div className="hm-label">From the Administration</div>
              <h2 className="hm-title">Words from Our Leaders</h2>
              <div className="hm-gold-line hm-gold-line-center"/>
            </div>
            <div className="hm-leader-grid">
              {leaderMessages.map((m,i)=>(
                <div key={m.id} className="hm-leader-card hm-fade" style={{transitionDelay:`${i*.1}s`}}>
                  <div className="hm-leader-head">
                    <img src={m.img} alt={m.title} className="hm-leader-photo"/>
                    <div className="hm-leader-name">{m.title}</div>
                    <div className="hm-leader-role">{m.role}</div>
                  </div>
                  <div className="hm-leader-body">
                    <p className="hm-leader-quote">{expandedLeader===m.id ? m.full : m.short}</p>
                    <button className="hm-leader-btn" onClick={()=>setExpandedLeader(expandedLeader===m.id?null:m.id)}>
                      {expandedLeader===m.id?'← Read Less':'Read Full Message →'}
                    </button>
                  </div>
                </div>
              ))}
            </div>
          </div>
        </section>

        {/* ORG CHART */}
        <section className="hm-section hm-org">
          <div className="hm-container">
            <div className="hm-center hm-fade" style={{marginBottom:40}}>
              <div className="hm-label" style={{justifyContent:'center'}}>Our Institution</div>
              <h2 className="hm-title hm-title-white">Leadership Structure</h2>
              <div className="hm-gold-line hm-gold-line-center"/>
              <p style={{color:'rgba(255,255,255,.5)',fontSize:14,marginTop:-32}}>Click any card to read their full message</p>
            </div>
            <div className="hm-fade" style={{display:'flex',justifyContent:'center',marginBottom:48}}>
              <div className="hm-org-tabs">
                {orgTabs.map((t,i)=>(
                  <button key={i} className={`hm-org-tab${orgTab===i?' active':''}`} onClick={()=>setOrgTab(i)}>{t}</button>
                ))}
              </div>
            </div>
            <AnimatePresence mode="wait">
              {orgTab===0 && (
                <motion.div key="founder" initial={{opacity:0,y:20}} animate={{opacity:1,y:0}} exit={{opacity:0,y:-16}} transition={{duration:.45}} className="hm-founder-slide">
                  <div className="hm-founder-photo-wrap">
                    <img src={founderImg} alt="Dr. Abdul Qadeer Khan" className="hm-founder-photo"/>
                    <div className="hm-founder-badge">🇵🇰</div>
                  </div>
                  <div className="hm-founder-name">Dr. Abdul Qadeer Khan</div>
                  <div className="hm-founder-role">Founder &amp; National Hero of Pakistan</div>
                  <p className="hm-founder-desc">A beacon of scientific achievement and national pride, Dr. A.Q. Khan's vision was to bring world-class education to every Pakistani student. His legacy lives on in every student who walks these halls.</p>
                  <Link to="/leadership/founder" className="hm-founder-link">Read Full Message →</Link>
                </motion.div>
              )}
              {orgTab===1 && (
                <motion.div key="ceo" initial={{opacity:0,y:20}} animate={{opacity:1,y:0}} exit={{opacity:0,y:-16}} transition={{duration:.45}} className="hm-founder-slide">
                  <div className="hm-founder-photo-wrap">
                    <img src={ceoImg1} alt="Dr. G.Q. Mohsin" className="hm-founder-photo"/>
                    <div className="hm-founder-badge">🏛️</div>
                  </div>
                  <div className="hm-founder-name">Dr. G.Q. Mohsin</div>
                  <div className="hm-founder-role">CEO · Dr. A.Q. Khan Institution</div>
                  <p className="hm-founder-desc">Dedicated to revolutionizing education beyond boundaries, fostering creativity, confidence, and holistic growth in every student.</p>
                  <Link to="/leadership/ceo" className="hm-founder-link">Read Full Message →</Link>
                </motion.div>
              )}
              {orgTab===2 && (
                <motion.div key="directors" initial={{opacity:0,y:20}} animate={{opacity:1,y:0}} exit={{opacity:0,y:-16}} transition={{duration:.45}}>
                  <div className="hm-board-grid">
                    {boardDirectors.map((d,i)=>(
                      <motion.div key={d.id} initial={{opacity:0,y:16}} animate={{opacity:1,y:0}} transition={{delay:i*.08}}>
                        <BoardCard person={d}/>
                      </motion.div>
                    ))}
                  </div>
                </motion.div>
              )}
              {orgTab===3 && (
                <motion.div key="governors" initial={{opacity:0,y:20}} animate={{opacity:1,y:0}} exit={{opacity:0,y:-16}} transition={{duration:.45}}>
                  <div className="hm-board-grid">
                    {boardGovernors.map((g,i)=>(
                      <motion.div key={g.id} initial={{opacity:0,y:16}} animate={{opacity:1,y:0}} transition={{delay:i*.08}}>
                        <BoardCard person={g}/>
                      </motion.div>
                    ))}
                  </div>
                </motion.div>
              )}
            </AnimatePresence>
          </div>
        </section>

        {/* FACULTY GRID */}
        <section className="hm-section hm-faculty-section">
          <div className="hm-container">
            <div className="hm-center hm-fade">
              <div className="hm-label" style={{justifyContent:'center'}}>Our People</div>
              <h2 className="hm-title">Expert Faculty</h2>
              <div className="hm-gold-line hm-gold-line-center"/>
              <p className="hm-desc" style={{margin:'-28px auto 0'}}>Meet the dedicated educators shaping the next generation. Click any card to view full profile.</p>
            </div>
            <div className="hm-faculty-grid">
              {facultyData.map((f,i)=><FacCard key={f.id} f={f} i={i}/>)}
            </div>
            <div className="hm-fac-view-all hm-fade">
              <Link to="/faculty" className="hm-btn-gold" style={{display:'inline-flex'}}>Meet All Faculty Members →</Link>
            </div>
          </div>
        </section>

        {/* EVENTS */}
        <section className="hm-section hm-events" id="events">
          <div className="hm-container">
            <div className="hm-center hm-fade">
              <div className="hm-label" style={{justifyContent:'center'}}>Campus Life</div>
              <h2 className="hm-title">Programs &amp; Events</h2>
              <div className="hm-gold-line hm-gold-line-center"/>
              <p className="hm-desc" style={{margin:'-28px auto 0'}}>Beyond academics — explore the vibrant events and activities that define life at Dr. A.Q. Khan College.</p>
            </div>
            <div className="hm-events-grid">
              {eventsData.map((ev,i)=>(
                <div key={i} className="hm-event-card hm-fade" style={{transitionDelay:`${i*.08}s`}}>
                  <img src={ev.img} alt={ev.title} className="hm-event-img"/>
                  <div className="hm-event-body">
                    <span className="hm-event-tag">{ev.tag}</span>
                    <div className="hm-event-title">{ev.title}</div>
                    <p className="hm-event-desc">{ev.desc}</p>
                  </div>
                </div>
              ))}
            </div>
          </div>
        </section>

        {/* ALUMNI — NEW SECTION */}
        <section className="hm-alumni">
          <div className="hm-container">
            <div className="hm-center hm-fade">
              <div className="hm-label" style={{justifyContent:'center'}}>Success Stories</div>
              <h2 className="hm-title hm-title-white">Our Alumni</h2>
              <div className="hm-gold-line hm-gold-line-center"/>
              <p className="hm-desc hm-desc-white" style={{margin:'-28px auto 0'}}>
                From doctors and engineers to national athletes and advocates — our graduates are making Pakistan proud.
              </p>
            </div>
            <div className="hm-alumni-grid" style={{marginTop:56}}>
              {alumniData.map((al,i)=><AlumCard key={i} al={al} i={i}/>)}
            </div>
          </div>
        </section>

        {/* CTA */}
        <div className="hm-cta">
          <div className="hm-cta-inner">
            <div className="hm-fade">
              <div className="hm-cta-title">Ready to Begin Your<br/><em>Academic Journey?</em></div>
              <p className="hm-cta-sub">Admissions are open. Join a community of curious minds and ambitious achievers.</p>
            </div>
            <div className="hm-cta-btns hm-fade" style={{transitionDelay:'0.15s'}}>
              <Link to="/admissions" className="hm-btn-gold">📄 Get Admission Form</Link>
              <Link to="/contact" className="hm-btn-ghost">📞 Contact Us</Link>
            </div>
          </div>
        </div>

        {/* FOOTER */}
        <footer className="hm-footer">
          <div className="hm-footer-inner">
            <div>
              <div className="hm-footer-brand-name">Dr. A.Q. Khan College</div>
              <p className="hm-footer-brand-desc">A premier institution on Harley Street, Rawalpindi — dedicated to academic excellence, character building, and shaping Pakistan's future leaders.</p>
              <div className="hm-footer-social">
                <a href="https://www.facebook.com/aqkhancollegeharleycampus/" className="hm-footer-social-btn" target="_blank" rel="noreferrer">f</a>
                <a href="#" className="hm-footer-social-btn">tw</a>
                <a href="#" className="hm-footer-social-btn">in</a>
              </div>
            </div>
            <div>
              <div className="hm-footer-col-title">Quick Links</div>
              <ul className="hm-footer-links">
                {[['Home','/'],['About','/about'],['Admissions','/admissions'],['Faculty','/faculty'],['Leadership','/leadership'],['Contact','/contact']].map(([l,p])=>(
                  <li key={p}><Link to={p}>{l}</Link></li>
                ))}
              </ul>
            </div>
            <div>
              <div className="hm-footer-col-title">Contact</div>
              <ul className="hm-footer-links">
                <li><a href="#">📍 3 Harley Street, Rawalpindi</a></li>
                <li><a href="tel:+923453300699">📞 +92 345 3300699</a></li>
                <li><a href="mailto:aqkhanedu@gmail.com">✉️ aqkhanedu@gmail.com</a></li>
                <li><a href="#">Mon–Fri: 8 am – 4 pm</a></li>
              </ul>
            </div>
          </div>
          <div className="hm-footer-bottom">
            <span className="hm-footer-copy">© 2026 Dr. A.Q. Khan College. All rights reserved.</span>
            <span className="hm-footer-credit">Designed by Zaib Fatima</span>
          </div>
        </footer>

      </div>
    </>
  );
}